export const IMG = {
  hero:
    "https://images.unsplash.com/photo-1765766601532-90e9b96320c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwZGFya3xlbnwwfHx8fDE3Nzc1OTEyODN8MA&ixlib=rb-4.1.0&q=85",
  bathroom:
    "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYXRocm9vbSUyMG1hcmJsZSUyMGludGVyaW9yfGVufDB8fHx8MTc3NzU5MTI4M3ww&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1776935359460-6c789e972e6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwZGFya3xlbnwwfHx8fDE3Nzc1OTEyODN8MA&ixlib=rb-4.1.0&q=85",
  painting:
    "https://images.pexels.com/photos/5493662/pexels-photo-5493662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blueprint:
    "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  livingRoom:
    "https://images.unsplash.com/photo-1776935359455-94263068537c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBkYXJrJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3Nzc1OTEyOTh8MA&ixlib=rb-4.1.0&q=85",
  // Additional curated images
  flooring:
    "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?auto=format&fit=crop&w=1200&q=80",
  cabinet:
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80",
  drywall:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
  exterior:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
  tile:
    "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=80",
  hallway:
    "https://images.unsplash.com/photo-1505577058444-a3dab90d4253?auto=format&fit=crop&w=1200&q=80",
  commercial:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
  masterBath:
    "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1200&q=80",
};

export const PHONE_DISPLAY = "(254) 550-0122";
export const PHONE_TEL = "+12545500122";
export const ADDRESS = "4912 Haverwood Ln, Dallas, TX 75287";
export const COMPANY = "GA SIGNATURE";
